import { Injectable } from '@angular/core';

export enum App {
  sw = 'sw',
  pw = 'pw',
  android = 'android',
  ios = 'ios',
  miniboard = 'miniboard'
}

export enum Browser {
  iosBrowser = 'iosBrowser',
  webBrowser = 'webBrowser',
  androidBrowser = 'androidBrowser',
}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public static versionCode = '10.6.2';
  public static appName: string = AppService.getAppName();
  public static appBrowser: string = AppService.getAppBrowser();
  constructor() { }

  private static getAppName() {
    const userAgent = navigator.userAgent.toLowerCase();
    // return App.android;
    // return App.pw;
    // return App.ios;
    if (userAgent.indexOf(' electron/') > -1) {
      return App.sw;
      // 'file:///var/containers/Bundle/'
    }
    let url = window.location + '';
    if(url.indexOf('https://localhost') > -1) {
      return App.android;
    }
    if (AppService.startWith(window.location + '', 'file')) {
      // return App.ios;
      if (userAgent.indexOf('android') > -1) {
        return App.android;
      } else {
        return App.ios;
      }
    } else {
      return App.pw;
      // return App.ios;
    }
  }

  private static getAppBrowser() {
    if (navigator.userAgent.match(/Android/i)) {
      return 'androidBrowser';
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      return 'iosBrowser';
    } else if (navigator.userAgent.toLowerCase().indexOf('macintosh') > -1 && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      return 'iosBrowser';
    } else {
      return 'webBrowser';
    }
  }

  public static getIOSVersion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      const version = [
        parseInt(v[1], 10),
        parseInt(v[2], 10),
        parseInt(v[3] || '0', 10)
      ]
      return parseFloat(version.join('.'));
    } else {
      return null;
    }
  }

  public static isIOS15Plus() {
    return AppService.getAppBrowser() === Browser.iosBrowser && AppService.getIOSVersion() >= 15;
  }

  public static isSoftware() {
    return AppService.isApp(App.sw);
  }

  public static isPW() {
    return AppService.isApp(App.pw);
  }

  public static isAndroid() {
    return AppService.isApp(App.android);
  }

  public static isIOS() {
    return AppService.isApp(App.ios);
  }

  private static isApp(app) {
    return AppService.appName === app;
  }

  public static startWith(str, beginStr) {
    if (str.substr(0, beginStr.length) === beginStr) {
      return true;
    }
    return false;
  }

  public static urlPrefix() {
    if (AppService.isIOS() || AppService.isAndroid()) {
      return 'https://www.naturalreaders.com';
    } else {
      return '..';
    }
  }

  public static getAppProductDevice() {
    let app = 'pw';
    let device = 'web';
    const product = 'pw';
    
    if (AppService.appName === App.pw && AppService.appBrowser === Browser.iosBrowser) {
      device = 'ios';
    }
    else if (AppService.appName === App.pw && AppService.appBrowser === Browser.androidBrowser) {
      device = 'android';
    }
    else if (AppService.isIOS()) {
      app = 'mobile_app';
      device = 'ios';
    } else if (AppService.isAndroid()) {
      app = 'mobile_app';
      device = 'android';
    }

    return { app, product, device };
  }
}
